import { NgModule }            from '@angular/core';
import { CommonModule }        from '@angular/common';

import { UtcDatePipe }         from './utc-date-pipe';

@NgModule({
    imports:      [ CommonModule ],
    declarations: [ UtcDatePipe ],
    exports: [ UtcDatePipe ]
})
export class SharedDirectivesModule { }


// WEBPACK FOOTER //
// ./src/directives/shared-directive.module.ts